import api from "./api";

const DEFAULT_INACTIVE_DAYS = 14;

// Repeat array params as `filter=a&filter=b` (what the Django endpoint reads),
// instead of axios' default `filter[]=a`.
export function serializeParams(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    (Array.isArray(value) ? value : [value]).forEach((item) => search.append(key, item));
  });
  return search.toString();
}

function analyticsConfig(
  {
    start_date,
    end_date,
    territory_id,
    comparison,
    comparison_start_date,
    comparison_end_date,
    filters,
    inactive_days,
  },
  options = {}
) {
  const params = { start_date, end_date };
  const optionalParams = {
    territory_id,
    comparison,
    comparison_start_date,
    comparison_end_date,
  };

  Object.entries(optionalParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params[key] = value;
    }
  });
  if (inactive_days != null && inactive_days !== DEFAULT_INACTIVE_DAYS) {
    params.inactive_days = inactive_days;
  }

  const config = { params };
  if (Array.isArray(filters) && filters.length) {
    params.filter = [...filters];
    config.paramsSerializer = { serialize: serializeParams };
  }
  if (options.signal) {
    config.signal = options.signal;
  }
  return config;
}

export async function getSalesAnalytics(request, options = {}) {
  const response = await api.get("/api/accounting/sales_analytics/", analyticsConfig(request, options));
  return response.data;
}

// Read-only: margin, reach, reorder rate, momentum and untapped customers per product.
export async function getProductOpportunities(request, options = {}) {
  const { inactive_days, ...rest } = request;
  const response = await api.get("/api/accounting/sales_analytics/products/", analyticsConfig(rest, options));
  return response.data;
}

// Read-only: customers behind their own usual buying pattern.
export async function getCustomerHealth({ as_of, territory_id, filters, min_weekly }, options = {}) {
  const params = {};
  if (as_of) params.as_of = as_of;
  if (territory_id != null && territory_id !== "") params.territory_id = territory_id;
  if (min_weekly != null && min_weekly !== "") params.min_weekly = min_weekly;
  const config = { params };
  if (Array.isArray(filters) && filters.length) {
    params.filter = [...filters];
    config.paramsSerializer = { serialize: serializeParams };
  }
  if (options.signal) config.signal = options.signal;
  const response = await api.get("/api/accounting/sales_analytics/customer_health/", config);
  return response.data;
}

// Read-only: per-salesman results, book coverage, retention and task follow-through.
export async function getSalesmanScorecard(request, options = {}) {
  const { inactive_days, filters, ...rest } = request;
  const response = await api.get("/api/accounting/sales_analytics/salesmen/", analyticsConfig(rest, options));
  return response.data;
}
